export const firstCharacter = (phoneNumber) => phoneNumber.substring(0, 1)